const getAchConsentContent = ({ accountName, amount, date }) => (
  <span>
    By clicking <strong>“Pay”</strong>, I authorize Swirepay, on behalf of <strong>{accountName}</strong>, 
    to verify my bank account information using bank records and consumer reports. 
    I further authorize <strong>{accountName}</strong> to initiate an ACH/electronic debit from my 
    checking or savings account in the amount of <strong>{amount}</strong> on <strong>{date}</strong>. 
    I agree that the ACH transactions I authorize comply with all applicable laws and regulations.
  </span>
);

export default getAchConsentContent;